import { gql } from '@apollo/client';

export const ADDRESS_ATTRIBUTES_FRAGMENT = gql`
  fragment AddressAttributesFragment on RestAddressAttributes {
    verified
    source
    firstName: first_name
    lastName: last_name
    addressLine1: address_line1
    addressLine2: address_line2
    countryCode: country_code
    postalCode: postal_code
    city
    state
    phone
    sameDayDeliveryNotes: same_day_delivery_notes
  }
`;

export const ADDRESS_FRAGMENT = gql`
  fragment AddressFragment on RestAddress {
    id
    type
    attributes @type(name: "RestAddressAttributes") {
      ...AddressAttributesFragment
    }
  }
  ${ADDRESS_ATTRIBUTES_FRAGMENT}
`;

export type RestAddressAttributes = {
  __typename: 'RestAddressAttributes';
  verified: boolean | null;
  source: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  phone: string;
  countryCode: string;
  sameDayDeliveryNotes?: string | null;
};

export type RestAddress = {
  __typename: 'RestAddress';
  id: string;
  type: 'address' | 'addresses';
  attributes: RestAddressAttributes;
};

export type RestAddressInput = {
  data: {
    type: 'address';
    attributes: {
      first_name: string;
      last_name: string;
      address_line1: string;
      address_line2: string;
      city: string;
      state: string;
      postal_code: string;
      phone: string;
      country_code: string;
      same_day_delivery_notes?: string | null;
    };
  };
  use_otp?: boolean;
};
